module.exports = __webpack_public_path__ + "static/island-logo-8d81287b0b62a6418e0a3ad9bf8b02f7.png";